import { styled, useTheme } from '../lib/styles';
import { withTokenProps } from 'foundations-components/utils/withTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
const InnerShell = withTokenProps(styled.div.withConfig({
  displayName: "CalendarViewShell__InnerShell",
  componentId: "sc-1jk6uf4-0"
})(props => props.cssStyles));
export const CalendarViewShell = ({
  children,
  calendarRef,
  'data-test-id': testId
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(InnerShell, Object.assign({
    ref: calendarRef,
    "data-test-id": testId,
    display: "flex"
  }, theme.uiAddonCalendars.calendarViewShell, {
    children: children
  }));
};